'use client';

import { useEffect } from 'react';

const MAX_RELOADS_PER_SESSION = 3;
const STORAGE_KEY = 'chunkErrorReloadCount';

const isChunkLoadError = (error: unknown): boolean => {
  if (!error || typeof error !== 'object') return false;
  const { name, message } = error as { name?: string; message?: string };
  if (name === 'ChunkLoadError') return true;
  return typeof message === 'string' && /Loading (chunk|CSS chunk) [\w.-]+ failed/i.test(message);
};

const tryReload = () => {
  const count = Number(sessionStorage.getItem(STORAGE_KEY) ?? '0');
  if (count >= MAX_RELOADS_PER_SESSION) return;
  sessionStorage.setItem(STORAGE_KEY, String(count + 1));
  window.location.reload();
};

const ChunkErrorHandler = () => {
  useEffect(() => {
    const onError = (event: ErrorEvent) => {
      if (isChunkLoadError(event.error)) tryReload();
    };
    const onRejection = (event: PromiseRejectionEvent) => {
      if (isChunkLoadError(event.reason)) tryReload();
    };

    window.addEventListener('error', onError);
    window.addEventListener('unhandledrejection', onRejection);
    return () => {
      window.removeEventListener('error', onError);
      window.removeEventListener('unhandledrejection', onRejection);
    };
  }, []);

  return null;
};

export default ChunkErrorHandler;
